// extracted by mini-css-extract-plugin
module.exports = {"content":"UserProfileArticles_content__21zBe","sending":"UserProfileArticles_sending__9j4s3"};